import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import HomeAuth from './HomeAuth';
import HomeNonAuth from './HomeNonAuth';

const Home = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <div className="loading-text">Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? <HomeAuth /> : <HomeNonAuth />;
};

export default Home;
